import Typography from '@mui/material/Typography';


export default function InfoNewbornText() {
  
  return (
<div>
    
    <Typography variant="h6" >

Whole Genome Sequencing (WGS) was performed using the Oxford Nanopore Technologies (ONT) PromethION platform with long-read sequencing technology. 
<br /><br />
For this module, your genetic data was scanned against the Recommended Uniform Screening Panel (RUSP) conditions.
This list was developed by leading healthcare experts and is recognized as the standard for newborn genetic screening in many regions.
<br /><br />
Accuracy:
<br /><br />
While sequencing results are highly reliable, no test can guarantee 100% certainty. 
Further confirmation by healthcare providers and family history assessments are important when interpreting the findings.

</Typography>  
</div>

   )
}